<template>
    <CommentModal @commentPosted="getOutgoingComments" :item-id="modalProps.itemId" :origin="modalProps.origin" :is-reply="true" :object-id="modalProps.objectId"></CommentModal>
     <div class="my-10">
        <div class="grid grid-cols-2 gap-20">
            <div class="flex flex-col gap-5">
                <h2 class="text-2xl font-bold">{{ $t('page.incoming') }}</h2>
                <div class="flex flex-col gap-5">
                    <CommentCard @replyToComment="openCommentModal" v-for="incom in incomingComments" :key="incom.id" :detail="incom"></CommentCard>
                </div>
                <div v-show="loadingIncoming === true" class="flex justify-center mx-auto w-full" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
                <div v-show="incomingComments.length === 0 && loadingIncoming === false">
                    <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_comments') }}</p>
                </div>
            </div>
            <div class="flex flex-col gap-5">
                <h2 class="text-2xl font-bold">{{ $t('page.outgoing') }}</h2>
                <div class="flex flex-col gap-5">
                    <CommentCard v-for="outcom in outgoingComments" :key="outcom.id" :detail="outcom" :is-my-replies="true"></CommentCard>
                </div>
                <div v-show="loadingOutcoming === true" class="flex justify-center mx-auto w-full" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
                <div v-show="outgoingComments.length === 0 && loadingOutcoming === false">
                    <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.no_comments') }}</p>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import api from '@/api';
import CommentCard from "@cmp/CommentCard.vue";
import { useAppStore } from '@/store'; // Import your Pinia store
import CommentModal from '@cmp/modals/CommentModal.vue'

export default {
    name: 'comments',
    components: {
        CommentCard,
        CommentModal
    },
    data(){
        return {
            loadingIncoming: false,
            loadingOutcoming: false,
          incomingComments: [],
          outgoingComments: [],
          modalProps: {
            itemId: null,
            origin: null
          }
        }
    },
    methods: {
        async getIncomingComments(){
            this.loadingIncoming = true
            try{
                const response = await api.get('comments/to_me/');
                this.incomingComments = response.data.results
            }catch(e){
                console.log(e)
            }
            this.loadingIncoming = false

        },
        async getOutgoingComments(){
            this.loadingOutcoming = true

            try{
                const response = await api.get('comments/from_me/')
                this.outgoingComments = response.data.results
            }catch(e){
                console.log(e)
            }
            this.loadingOutcoming = false

        },
        openCommentModal(data){
            this.modalProps.itemId = data.itemId
            this.modalProps.origin = data.contentType
            this.modalProps.objectId = data.objectId
            this.$store.modals.commentModal = true
        },
    },
    computed: {

    },
    mounted(){
        const appStore = useAppStore();
        if (appStore.userData) {
            this.getIncomingComments()
            this.getOutgoingComments()
        }
        else{
            const unwatch = this.$watch(
                () => appStore.userData,
                (newVal) => {
                    if (newVal) {
                     console.log('newVal', newVal)

                        this.getIncomingComments();
                        this.getOutgoingComments();
                        unwatch(); // Unwatch once the data is fetched
                    }
                }
            );
        }
    }
}

</script>